import type { RouteRecordRaw } from 'vue-router';

const MainLayout = () => import('@/shared/layouts/pages/MainLayout/index.vue');
const NotificationPage = () => import('../pages/notifications/index.vue');

export const notificationRoutes: Array<RouteRecordRaw> = [
  {
    path: '/notificaciones',
    component: MainLayout,
    children: [
      {
        path: '',
        name: 'notifications',
        component: NotificationPage,
        meta: {
          requiresAuth: true,
          title: 'Notifications',
        },
      },
    ],
  },
];
